import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';

// Public-site replacement for usePublic() (fetch of a synced JSON file) —
// reads a Firestore collection directly, once on mount. Same ergonomics:
// returns [] initially and on error, never throws.
function useFirestoreCollection(name, mapFn) {
	const [data, setData] = useState([]);

	useEffect(() => {
		let cancelled = false;
		getDocs(collection(db, name))
			.then(snap => {
				if (cancelled) return;
				const rows = snap.docs.map(d => {
					const row = { id: d.id, ...d.data() };
					return mapFn ? mapFn(row) : row;
				});
				setData(rows);
			})
			.catch(() => { if (!cancelled) setData([]); });
		return () => { cancelled = true; };
	}, [name, mapFn]);

	return data;
}

// projects Firestore docs (name, nameid, year, ...) don't carry every field
// the public card components expect — this fills the same defaults
// syncProjectsConfig used to bake into the JSON at write-time, just applied
// at read-time instead.
export function projectFromDoc(data) {
	return {
		...data,
		title: data.title ?? data.name ?? data.nameid,
		buttonText: data.buttonText ?? 'MoreInfo',
		markdownFile: data.markdownFile ?? `${data.nameid}.md`,
		services: data.services ?? [],
		gallery: data.gallery ?? [],
		image: data.image ?? '',
		model_full: data.model_full ?? '',
	};
}

export default useFirestoreCollection;
